<template>
  <div>
    <v-btn
      :class="!$vuetify.dark ? 'secondary' : ''"
      :color="$vuetify.dark ? 'secondary' : ''"
      :disabled="overrideOptions.length === 0"
      :outline="$vuetify.dark"
      flat
      @click.stop="dialogChangeState = true"
    >
      <v-icon>lock_open</v-icon>
      <span class="ml-2 text-capitalize">Override Activity</span>
    </v-btn>
    <v-dialog v-model="dialogChangeState" max-width="80%" persistent>
      <v-card>
        <v-toolbar class="body-2 beez-bold" dense flat
          >Override Workflow Activity
          <v-spacer />
          <v-btn flat icon @click="dialogChangeState = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-flex fulid>
            <v-layout class="pb-2" row>
              <v-flex grow>
                <v-radio-group v-model="activityOptions">
                  <template slot="label">
                    <div class="pb-2">
                      The Workflow can be made to process
                      <strong>the next steps with additional inputs</strong> or
                      killed to stop any further processing, Please choose the
                      options accordingly
                      <br />
                      <div class="pt-2">
                        <v-icon class="warning--text">warning</v-icon>
                        <strong class="pl-2"
                          >Changing the Workflow flow manually can cause
                          unpredictable results, these options should be
                          exercised with high caution</strong
                        >
                      </div>
                    </div>
                  </template>
                  <v-radio v-if="checkOptions('Signal')" value="Signal">
                    <template slot="label">
                      <div>
                        To
                        <strong class="secondary--text">
                          Send a Signal for progressing next step of
                          workflow</strong
                        >
                      </div>
                    </template>
                  </v-radio>
                  <v-radio v-if="checkOptions('Obsolete')" value="Obsolete">
                    <template slot="label">
                      <div>
                        To
                        <strong class="secondary--text">
                          Kill workflow Execution</strong
                        >
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout class="pa-2" row>
              <v-flex grow>
                <v-card v-if="activityOptions === 'Signal'">
                  <v-toolbar card class="body-2 beez-bold" dense>
                    Proceed to Next Workflow Step
                    <v-spacer></v-spacer>
                    <v-btn @click="sendSignal" class="text-capitalize"
                      >Proceed to next step</v-btn
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-flex xs12>
                      <div>
                        <v-icon class="warning--text">warning</v-icon>
                        <strong class="pl-2">
                          This enables administrator to proceed the next step
                          execution with additional inputs, The additional
                          inputs are expected to be provided in a Json format as
                          a Json Object (not Array) matching the variable json
                          structure. This option to be exercise with extreme
                          caution.
                        </strong>
                      </div>
                      <v-jsoneditor
                        key="jsonEditor"
                        v-model="additionalInputValue"
                        :options="jsonOptions"
                        :plus="true"
                        height="400px"
                      >
                      </v-jsoneditor>
                    </v-flex>
                  </v-card-text>
                </v-card>
                <v-card v-if="activityOptions === 'Obsolete'">
                  <v-toolbar card class="body-2 beez-bold" dense>
                    Make Workflow Execution Obsolete / Kill Workflow Execution
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="killWorkflowExecution"
                      class="text-capitalize"
                      >Kill Workflow Execution</v-btn
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-flex xs12>
                      <div>
                        <v-icon class="warning--text">warning</v-icon>
                        <strong class="pl-2">
                          This enables administrator to Kill Workflow Execution.
                          This option to be exercise with extreme caution.
                        </strong>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'ExecutionActivityAdminTask',
  data: function() {
    return {
      overrideOptions: [],
      additionalInputs: false,
      additionalInputValue: {
        variable_key: {
          value: 'variable_value',
          type: 'STRING',
          flowVariable: false,
          objectTypeName: 'java.lang.String'
        }
      },
      dialogChangeState: false,
      activityOptions: null,
      jsonOptions: { mode: 'code' }
    }
  },
  props: {
    activity: Object
  },
  async mounted() {
    await this.getOverrideOptionsActivity(
      this.activity.camundaProperties.executionId
    )
  },
  methods: {
    getOverrideOptionsActivity(executionId) {
      axios
        .get(`/api/core/activity/${executionId}/override-options`)
        .then(response => {
          this.overrideOptions = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkOptions(option) {
      if (this.overrideOptions && this.overrideOptions.length > 0) {
        return this.overrideOptions.indexOf(option.toUpperCase()) > -1
      } else {
        return false
      }
    },
    async raiseOverrideActivity(overrideActivity) {
      try {
        axios.post(
          `/api/core/activity/${overrideActivity.executionId}/status/override`,
          overrideActivity
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to perform Workflow override action',
          description: e.response
            ? e.response.data.message
            : 'Unable to perform Workflow override action',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },
    sendSignal() {
      let activityOverride = {}
      activityOverride.executionId = this.activity.camundaProperties.executionId
      activityOverride.businessKey = this.activity.stateId
      activityOverride.stackId = this.activity.hexId
      activityOverride.options = 'SIGNAL'
      this.setInputs(activityOverride, this.additionalInputValue)
      this.raiseOverrideActivity(activityOverride)
      this.dialogChangeState = false
    },
    killWorkflowExecution() {
      let activityOverride = {}
      activityOverride.executionId = this.activity.camundaProperties.executionId
      activityOverride.businessKey = this.activity.stateId
      activityOverride.stackId = this.activity.hexId
      activityOverride.options = 'OBSOLETE'
      this.raiseOverrideActivity(activityOverride)
      this.dialogChangeState = false
    },
    setInputs: function(activityOverride, inputs) {
      activityOverride.inputs = {}
      let inputArray = Object.keys(inputs)
      for (let i = 0; i < inputArray.length; i++) {
        activityOverride.inputs[inputArray[i]] = {
          value: inputs[[inputArray[i]]],
          type: 'STRING',
          objectTypeName: 'java.lang.String',
          flowVariable: false
        }
      }
    }
  }
}
</script>

<style scoped></style>
